import React, { useState, useRef, useEffect } from 'react';
import { validators, dates } from 'investira.sdk';
import { useSelector, useDispatch } from 'react-redux';
import {
  acReportsDurationParamsChanged,
  acReportsVarParamsChanged,
  acReportsEnquadramentoParamsChanged,
  acReportsStresstestParamsChanged
} from '../store/actions';

const withSaveParams = (Component, pOptions = {}) => {
  function WrapComponent(props) {
    const sessionCurrentEntidadeId = sessionStorage.getItem('current_entidade_id');

    const store = useSelector(store => store);
    const storeDispatch = useDispatch();

    const { user, reports } = store;

    function saveParams(pType, pParams) {
      const xActions = {
        duration: acReportsDurationParamsChanged,
        enquadramento: acReportsEnquadramentoParamsChanged,
        var: acReportsVarParamsChanged,
        stresstest: acReportsStresstestParamsChanged
      };

      const xAction = xActions[pType];

      if (!validators.isNull(xAction)) {
        storeDispatch(
          xAction({
            usuario_id: user.usuario_id,
            current_entidade_id: sessionCurrentEntidadeId,
            params: pParams
          })
        );
      } else {
        console.error('Tipo de output não existe ou ausente.');
      }
    }

    function storedParams(pType, pOutput) {
      try {
        if (!user || !user.usuario_id) {
          console.error('Usuário não definido ou sem usuario_id.');
          return {};
        }

        if (!sessionCurrentEntidadeId) {
          console.error('current_entidade_id não encontrado na sessão.');
          return {};
        }

        if (!reports || !reports.params) {
          console.error('Objeto reports ou reports.params não definido.');
          return {};
        }

        if (!reports.params[pType]) {
          console.warn(`Tipo de parâmetro '${pType}' não encontrado em reports.params.`);
          return !validators.isEmpty(pOutput.request)
            ? { ...pOutput.request, data: pOutput.request.data }
            : {};
        }

        const xKey = `${user.usuario_id}${sessionCurrentEntidadeId}`;

        const xStoredParams = reports.params[pType][xKey];

        if (!validators.isEmpty(xStoredParams)) {
          return { ...xStoredParams, data: xStoredParams.data };
        }

        if (!validators.isEmpty(pOutput.request)) {
          return {
            ...pOutput.request,
            data: pOutput.request.data
          };
        }
        console.info('No Params');
        return {};
      } catch (error) {
        console.error('Erro ao recuperar parâmetros armazenados:', error);
        return {};
      }
    }

    const xProps = {
      ...props,
      saveParams,
      storedParams
    };

    return (
      <>
        <Component {...xProps} />
      </>
    );
  }

  return WrapComponent;
};

export default withSaveParams;
